import React, { useEffect, useState } from "react";
import CloseForm from "../Master/CloseForm";
import "../../css_files/Technician/ViewEditVoucher.css";
import axiosInstance from "../../api";
import moment from "moment";
import html2pdf from "html2pdf.js";

function ViewEditVoucher({ setShowVoucher, voucherId, refresh, setrefresh }) {
  const [voucherData, setVoucherData] = useState(null);
  const [files, setfiles]= useState([]);
  const [fileNames, setfileNames]= useState("");
  const [loading, setloading]= useState(false);
  const voucherStatus = ["Pending", "Approved", "Rejected"];

  useEffect(() => {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/Voucher/GetSingleVoucher/${voucherId}`
      )
      .then((res) => {
        setVoucherData(res.data);
      })
      .catch(console.log);
  }, [voucherId]);

  /*function handleSubmit(e) {
    e.preventDefault();
    setloading(true);
    const formdata = new FormData();
    formdata.append("Amount", voucherData?.amount);
    formdata.append("VoucherDate", voucherData?.voucherDate);
    formdata.append("Description", voucherData?.description);

    for (const file of files) {
      formdata.append("Files", file);
    }
    formdata.append("Id", voucherId);
    formdata.append("FileNames", fileNames);

    const apiCall =
      axiosInstance.put(`${process.env.REACT_APP_API_URL}/api/Voucher/UpdateVoucher`, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })

    apiCall
      .then(() => {
        setrefresh(!refresh);
        setShowVoucher(false);
      })
      .catch(console.log)
      .finally(() => setloading(false));
  }*/

      const generateHTML = (data) => {
          const vouchers = data.vouchers ?? [];
      
          const totalAmount = vouchers.reduce(
            (sum, v) => sum + (v.amount ?? 0.0),
            0.0
          );
      
          return `
        <html>
          <body style="padding: 20px; margin: 0; box-sizing: border-box; font-family: sans-serif; min-height: 100vh; width:100%; display:flex; flex-direction: column;">
      
            <!-- HEADER -->
            <div style="text-align:center;">
              <h2>ROSS BOILERS</h2>
              <p>No.33, Burhani Industrial Estate, Kondhwa (Bk), Pune - 411048</p>
              <h3>DEBIT VOUCHER</h3>
            </div>
      
            <br/>
      
            <!-- DETAILS -->
            <div width="100%" style="display: grid; grid-template-columns: 1fr 1fr; column-gap: 1rem;">
             
                <span><strong>Pay To:</strong> ${data.userId || "-"}</span>
              
                <span><strong>Account Of:</strong> ${
                  data.ticket?.customer?.orgName || "-"
                }</span>
                <span><strong>Voucher No:</strong> ${data.voucherNumber || "-"}</span>
              
                <span><strong>Date:</strong> ${moment(
                  new Date(data?.updatedDate ?? data?.createdDate)
                ).format("DD/MM/YYYY")}</span>
                <span><strong>Ticket ID:</strong> ${
                  data.ticket?.seriesId || "-"
                }</span>
                <span><strong>Voucher Status:</strong> ${voucherStatus[data?.voucherStatus]}</span>
                <span><strong>${data?.voucherStatus == 2 ? "Reject Reason: ":""}</strong> ${data?.voucherStatus == 2 ? data?.rejectReason:""}</span>
            </div>
      
            <!-- PARTICULARS TITLE -->
            <h3>PARTICULARS</h3>
      
            <!-- TABLE -->
            <table border="1" cellspacing="0" cellpadding="6" width="100%" style="border-collapse: collapse; text-align:center;">
              <thead>
                <tr>       
                  <th width="15%">Date</th>
                  <th width="30%">Description</th>
                  <th width="25%">Remark</th>
                  <th width="15%">Distance Travelled</th>
                  <th width="15%">Amount (₹)</th>
                </tr>
              </thead>
              <tbody>
                ${vouchers
                  .map(
                    (v) => `
                  <tr>
                    <td width="15%">${
                      v.voucherDate ? moment(v.voucherDate).format("DD/MM/YYYY") : "-"
                    }</td>
                    <td width="30%" style="text-align:left;">${
                      v.description || "-"
                    }</td>
                    <td width="25%" style="text-align:left;">${v.remarks || "-"}</td>
                    <td width="15%">${v?.distanceTravelled ?? "-"}</td>
                    <td width="15%">${parseFloat(v.amount).toFixed(2)}</td>
                  </tr>
                `
                  )
                  .join("")}
              </tbody>
            </table>
      
            <br/>
      
            <!-- TOTALS -->
            <table width="100%">
              
              <tr>
                <td style="text-align:right;"><b>Grand Total</b></td>
                <td style="text-align:right;">₹ ${parseFloat(totalAmount).toFixed(
                  2
                )}</td>
              </tr>
            </table>
      
            <br/><br/><br/>
      
            <!-- SIGNATURES -->
            <table width="100%" style="margin-top: auto;">
              <tr>
                <td>Receiver’s Sign</td>
                <td style="text-align:center;">Verified By</td>
                <td style="text-align:right;">Authorized By</td>
              </tr>
            </table>
      
          </body>
        </html>
        `;
        };

  return (
    <div className="view-edit-voucher-technician">
        <h2>View Voucher</h2>
        <i class="fa-solid fa-file-pdf fa-2x" title="Export to Pdf" onClick={()=>{
          const html = generateHTML(voucherData);
        const element = document.createElement("div");
        element.innerHTML = html;

        const options = {
          margin: 0.5,
          filename: `voucherReport${Date.now()}.pdf`,
          image: { type: "jpeg", quality: 1 },
          html2canvas: { scale: 2 },
          jsPDF: {
            unit: "in",
            format: "a4",
            orientation: "portrait",
          },
        };

        html2pdf().set(options).from(element).save();
        }}></i>
        <div>
          <p><strong>Voucher Number: </strong>{voucherData?.voucherNumber}</p>
          <p><strong>Ticket Id: </strong>{voucherData?.ticket?.seriesId}</p>
          <p><strong>Username: </strong>{voucherData?.userId}</p>
          <p><strong>Status: </strong>{voucherStatus[voucherData?.voucherStatus]}</p>
          {voucherData?.voucherStatus == 2 && <p><strong>Reject Reason: </strong>{voucherData?.rejectReason}</p>}
          <p><strong>Vouchers: </strong>{voucherData?.vouchers?.length}</p>
          {voucherData?.vouchers?.map(x=>(
            <aside>
              <p><strong>Voucher Date: </strong>{x?.voucherDate ? moment(new Date(x?.voucherDate)).format("DD/MM/YYYY"):"-"}</p>
              <p><strong>Amount: </strong>{parseFloat(x?.amount).toFixed(2)}</p>
              <p><strong>Description: </strong>{x?.description}</p>
              {x?.distanceTravelled && <p><strong>Distance Travelled: </strong>{x?.distanceTravelled} km</p>}
              <p><strong>Remarks: </strong>{x?.remarks}</p>
              {x?.fileNames?.split(",")?.every(x=> x != "") && <>
              <p><strong>Files: </strong></p>
              <ul>
                {x?.fileNames?.split(",")?.map(x=>(
                  <li>
                    <a href={`${process.env.REACT_APP_API_URL}/voucherFiles/${x}`}>{x}</a>
                  </li>
                ))}
              </ul>
              </>}
            </aside>
          ))}
        </div>
        <CloseForm close={setShowVoucher} />
    </div>
  );
}

export default ViewEditVoucher;
